/**
 * Module dependencies.
 */

import {
  CategoryWrapper,
  Description,
  Image,
  Title,
  Wrapper,
} from './catalog-categories.style';

import { Container } from 'components/atoms/container/container';
import { JSX, useMemo } from 'react';
import { Link } from 'components/atoms/link/link';
import { compact, snakeCase } from 'lodash';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  catalogCategories: any;
};

/**
 * Export `CatalogCategories` component.
 */

export function CatalogCategories({ catalogCategories }: Props): JSX.Element {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const categories = useMemo(() => {
    return compact(
      catalogCategories.map((category: any) => {
        if (category.subCategories.length === 0) {
          return null;
        }

        return {
          description: `${category.description[lang]}`,
          image: category.image,
          link: `/catalog/${category.id}-${snakeCase(category.title[lang])}`,
          title: category.title[lang],
        };
      }),
    );
  }, [catalogCategories, lang]);

  return (
    <Container>
      <Wrapper>
        {categories.map((category: any, index: number) => {
          const invert = Math.round(index % 2) === 1;

          return (
            <Link ghost href={category.link} key={index}>
              <CategoryWrapper invert={invert} key={index}>
                <Image cover image={category.image} />

                <Title invert={invert}>{category.title}</Title>

                <Description invert={invert}>
                  {category.description}
                </Description>
              </CategoryWrapper>
            </Link>
          );
        })}
      </Wrapper>
    </Container>
  );
}
